import React, { createContext } from "react";
import useToast from "../custom_hooks/useToast";
import Toast from "../components/toastr/Toast";

let ToastContext;
let { Provider } = (ToastContext = createContext());

let ToastProvider = ({ children }) => {
  let { toastList, toastProperties, autoDeleteTime, showToast, showError, position, autoDelete, dismissTime } = useToast();
  return (
    <Provider value={{ toastList, toastProperties, autoDeleteTime, showToast, showError, position, autoDelete, dismissTime }}>
      <Toast />
      {children}
    </Provider>
  );
};

export { 
  ToastContext, ToastProvider
};